import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { pushToDataLayer } from "@/lib/dataLayer";

const DataLayerBridge = () => {
  const location = useLocation();
  const isFirst = useRef(true);

  useEffect(() => {
    // Skip the initial page load (GTM handles that natively)
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }

    // Small delay so SEOHead / Helmet updates document.title first
    const t = setTimeout(() => {
      pushToDataLayer("virtual_page_view", {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }, 120);

    return () => clearTimeout(t);
  }, [location]);

  return null;
};

export default DataLayerBridge;
